module.exports = __webpack_public_path__ + "img/info2.62fcdbde.png";